import { WebViewComponent } from '@/components/WebView'
import { useStore } from '@/models'

const ABOUT_URL = 'https://pokerpower.com'
const ABOUT_URL_DEV = 'https://pokerpower.com'

export default function () {
  const {
    environment: { stage }
  } = useStore()
  const url = stage === 'prod' ? ABOUT_URL : ABOUT_URL_DEV
  return <WebViewComponent url={url} />
}
